/**
 * Retorna a cor no formato rgb(r, g, b) ou rgba(r, g, b, a)
 * de acordo com o nome da variavel passada por parametro
 * @param {String} nomeDaVariavelCSS Nome da variável CSS
 * @param {Number} opacity Opacidade desejada
 */
export function getColorRGBByCSSVariable(nomeDaVariavelCSS, opacity) {
	const rgb = getComputedStyle(document.body).getPropertyValue(nomeDaVariavelCSS)
	if (opacity) {
		return `rgba(${rgb}, ${opacity})`
	} else {
		return `rgb(${rgb})`
	}
}

/**
 * Retorna a cor no formato Hexadecimal de acordo com o nome
 * da variavel passada por parametro
 * @param {String} nomeDaVariavelCSS Nome da variável CSS
 */
export function getColorHexByCSSVariable(nomeDaVariavelCSS) {
	const rgb = getComputedStyle(document.body).getPropertyValue(nomeDaVariavelCSS)
	return RGBToHex(...rgb.split(',').map((numero) => parseInt(numero)))
}

/**
 * Converte cores RGB para Hexadecimal
 * @param {Number} r Red
 * @param {Number} g Green
 * @param {Number} b Blue
 */
function RGBToHex(r, g, b) {
	r = r.toString(16)
	g = g.toString(16)
	b = b.toString(16)

	if (r.length == 1) r = '0' + r
	if (g.length == 1) g = '0' + g
	if (b.length == 1) b = '0' + b

	return '#' + r + g + b
}
